<template>
  <div class="spaceCenter">
    <div>
      <div class="spaceLeft item-box">
        <label>祺信笔数：</label>
        <span class="text-color-blue" style="margin-right:5px;">{{ total }}
        </span>
        笔
      </div>
      <div class="spaceLeft item-box">
        <label>祺信面额：</label>
        <span class="text-color-gold" style="margin-right:5px;">{{ totalAmt | splitK }}
        </span>
        元
      </div>
      <div class="spaceLeft item-box">
        <label>交易密码：</label>
        <a-input type="password" v-model="txnPwd" class="item-input" />
      </div>
      <div class="spaceLeft item-box">
        <label>是否担保：</label>
        <div style="width:200px">
          <a-select v-model="canBeModified" :allowClear="true" option-label-prop="label" style="width:100%">
            <a-select-option v-for="item in canBeModifiedList" :key="item.value" :value="item.value" :label="item.name">{{
              item.name }}</a-select-option>
          </a-select>
        </div>
      </div>

      <div v-if="canBeModified == 1" class="spaceCenter item-box">
        <a-radio-group name="importType" v-model="importData.importType">
          <a-radio v-for="item in importType" :value="item.value" :key="item.value">
            {{ item.name }}
          </a-radio>
        </a-radio-group>
      </div>
      <div v-if="canBeModified == 1" class="spaceLeft item-box">
        <label>担保企业：</label>
        <div style="width:200px">
          <a-input v-show="importData.importType == 2" v-model="importData.tenantName2" placeholder="请输入" />
          <select-search v-show="importData.importType == 1" v-model="importData.tenantObj" :searchSource="true"
            :dataSource="importOption" :other="true" headNameFirst="担保企业" headNameSecond="社会信用代码" valuePorp="cstOrgCode"
            labelPorp="cstNm" @handleChange="changeTenant" @handleSearch="handleSearchImport"></select-search>
        </div>
      </div>
      <div class="spaceCenter model-footer-btns">
        <a-button @click="modalCancel">返回</a-button>
        <a-button @click="modalOk" type="primary" :loading="modalLoad" :disabled="!txnPwd">确认</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { verifyTradePassword } from "@/api/gold.js";
import { doSaveGuaranteeApi } from "@/api/guarantee.js";
import { circleQuery } from "@/api/circle.js";
import {
  selectSellerCstByName,
} from "@/api/payable.js";
export default {
  props: ["confirmData", "confirmModalData", "overdueRate"],
  name: "confirmPasswordModal",
  data() {
    return {
      modalLoad: false,
      total: this.confirmData.length,
      txnPwd: "",
      canBeModifiedList: [
        { name: "是", value: 1 },
        { name: "否", value: 0 }
      ],
      canBeModified: 0,
      importType: [
        { name: "圈子", value: "1" },
        { name: "键入", value: "2" }
      ],
      importData: {
        importType: "1",
        tenantName2: undefined, //键入值
        tenantObj: {}
      },
      importOption: []
    };
  },
  computed: {
    totalAmt() {
      let list = this.confirmData || [];
      let sum = 0;
      list.forEach(i => (sum += i.gldTAmt));
      return sum;
    }
  },
  created() { },
  mounted() { },
  methods: {
    // 卖方选项变化
    changeTenant(data, node) {
      this.importData.guaranteeCstId = node.guaranteeCstId;
    },
    // 导入弹窗选择卖方名称
    handleSearchImport(value, data) {
      circleQuery({
        tab: 2,
        pageSize: 10,
        pageNum: 1
      })
        .then(res => {
          // this.formConfig.forEach((item, index) => {
          //   if (item.label == "卖方名称") {
          //     this.formConfig[index].option = res.data.grid.list;
          this.importOption = res.data.grid.list;
          //   }
          // });
        })
        .catch(error => {
          console.log(error);
        });
    },
    modalOk(e) {
      this.modalLoad = true;
      let params = { tradePassword: this.txnPwd };
      verifyTradePassword(params, true)
        .then(res => {
          const data = [];
          for (const item of this.confirmModalData.goldList) {
            data.push({
              gldId: item.gldId,
              gldAmt: item.gldTAmt,
              estb: item.estbId,
              estbDay: item.startDate,
              exDay: this.utils.dateFormat(new Date(item.exDat), "YYYY-mm-dd"), // 转YYYY-mm-dd
              rspbPsnId: item.estbLimitMap && item.estbLimitMap.rspbPsnId,
              hdlInstId: item.estbLimitMap && item.estbLimitMap.hdlInstId,
              hdlDt: item.estbLimitMap && item.estbLimitMap.hdlDt,
              tenantId: this.$store.getters["home/getTenant"].tenantId
            });
          }
          console.log(data, 1111);
          if (this.canBeModified == '1' && this.importData.importType == "2") {
            if (!this.importData.tenantName2) {
              this.$message.error("请填写担保企业");
              this.modalLoad = false;
              return;
            }
            selectSellerCstByName({ userName: this.importData.tenantName2 })
              .then(res => {
                let list = res.data.grid.list || [];
                if (list[0]) {
                  this.importData.guaranteeCstId = list[0].guaranteeCstId
                  this.importData.tenantName2 = list[0].userName
                }
                this.handleSubmit(data)
              })
              .catch(err => {
                console.log(err);
                this.modalLoad = false;
              });
          }
          if (this.canBeModified == '1' && this.importData.importType == '1') {
            if (!this.importData.guaranteeCstId) {
              this.$message.error("请填写担保企业");
              this.modalLoad = false;
              return;
            }
            this.handleSubmit(data)
          }
          if (this.canBeModified == '0') {
            this.handleSubmit(data)
          }
        })
        .catch(error => {
          console.log(error);
          this.modalLoad = false;
          this.$emit("error", error);
        });
    },
    handleSubmit(data) {
      let p = {
        fkcnhNo: this.confirmData[0].fkcnhNo,
        overdueRateVal: String(this.overdueRate),
        guarantorName: "",
        guaranteeFlag: 0,
        data: JSON.stringify(data),
        list: JSON.stringify(this.confirmModalData.goldList),
        txnPwd: this.utils.getPasswordEncryptString(this.txnPwd),
        guaranteeCstId: this.importData.guaranteeCstId
      };
      const self = this;
      doSaveGuaranteeApi(p)
        .then(res => {
          this.$success({
            calss: "self-confirm",
            title: "提交成功",
            content: "已提交成功,请等待复核!",
            okText: "确定",
            onOk() {
              self.$emit("ok", res.data);
              self.modalLoad = false;
            }
          });
        })
        .catch(error => {
          console.log(error);
          this.modalLoad = false;
          this.$emit("error", error);
        });
    },
    modalCancel(e) {
      this.modalLoad = false;
      this.$emit("cancel");
    }
  }
};
</script>
<style scoped>
.item-box>label {
  min-width: 70px;
}

.item-box {
  margin: 0 15px 15px 0;
}

.item-input {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/table-find-rcvb/confirm-password-modal.vue